import PricingStrategyDTO from '../../../openapi/src/model/PricingStrategyDTO'

var PricingStrategyMixin = {
  methods: {
    createDto(data) {
      if (!data) data = {}

      // we remove from data all strategies marked as deleted
      Object.keys(data)
        .filter((key) => key.endsWith('_strategies') && data[key])
        .forEach((key) => {
          data[key] = data[key].filter((r) => !(r.hasOwnProperty('deleted') && r.deleted))
        })

      var dto = PricingStrategyDTO.constructFromObject(data)

      if (!dto.hasOwnProperty('priority')) dto.priority = 0
      if (!dto.hasOwnProperty('overriden')) dto.overriden = false
      if (!dto.hasOwnProperty('booking_windows')) dto.booking_windows = []
      if (!dto.hasOwnProperty('booking_days_of_week')) dto.booking_days_of_week = []
      if (!dto.hasOwnProperty('room_strategies')) dto.room_strategies = []
      if (!dto.hasOwnProperty('board_strategies')) dto.board_strategies = []
      // eslint-disable-next-line
      if (!dto.hasOwnProperty('channel_strategies')) dto.channel_strategies = []
      if (!dto.hasOwnProperty('pax_strategies')) dto.pax_strategies = []
      // eslint-disable-next-line
      if (!dto.hasOwnProperty('compset_strategies')) dto.compset_strategies = []
      if (!dto.hasOwnProperty('offers_strategies')) dto.offers_strategies = []
      if (!dto.hasOwnProperty('rates_strategies')) dto.rates_strategies = []

      return dto
    },
  },
}

export default PricingStrategyMixin
